import styled from "styled-components";
import { Space } from "task-eva-ui";

export const ServiceText = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #e8ebf0;
  word-break: break-word;
  &:last-child {
    padding-bottom: 8px;
  }
`;
export const ServiceTitle = styled.div`
  padding-top: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #8d8f95;
`;
export const StyledSpace = styled(Space)`
  width: calc(100% - 9px);
  padding-left: 9px;
`;
export const HumanServiceWrapper = styled.div<{ isFox: boolean }>`
  width: ${(p) => (p.isFox ? "284px" : "212px")};
  height: max-content;
  box-sizing: border-box;
  padding: 0 12px 0 10px;
  font-size: 14px;
  background: #343538;
  > * {
    border-bottom: 1px solid #3d3f45;
    &:last-child {
      border: unset;
    }
  }
  a,
  .service-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    height: 100%;
    width: 100%;
    color: ${(p) => (p.isFox ? "#E8EBF0" : "#BFC2C3")};
  }
  ${ServiceText} {
    font-size: ${(p) => (p.isFox ? "16px" : "18px")};
  }
  .message-icon {
    position: relative;
  }
`;

export const BadgeWrapper = styled.div`
  background-color: #ffc266;
  padding: 0px 4px;
  position: absolute;
  color: #27282a;
  font-size: 8px;
  border-radius: 8px;
  left: 10px;
  top: -7px;
`;
